export enum LoanSettlementStatus {
    settlementMoneyReceived = 'settlementMoneyReceived',
    complete = 'complete'
}
